import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rc-status-indicator" }

import { toRef } from 'vue';
import { RcStatusIndicatorProps } from './types';
import { useStatusColors } from '@components/utils/status';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcStatusIndicator',
  props: {
    shape: {},
    status: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v37fbfce4": (_unref(backgroundColor)),
  "v66b4ec26": (_unref(borderColor))
}))

const props = __props;

const status = toRef(props, 'status');
const { backgroundColor, borderColor } = useStatusColors(status, 'solid');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["shape", {[props.shape]: true, [props.status]: true}])
    }, null, 2)
  ]))
}
}

})